var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "join"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": _vm.homeLogo,
      "alt": ""
    }
  }), _c('span', [_vm._v(" " + _vm._s(_vm.$cm.title) + " ")])]), _c('p', [_vm._v(_vm._s(_vm.$t('start.partyId')) + ":")]), _c('el-input', {
    attrs: {
      "placeholder": _vm.$t('start.placeholder'),
      "clearable": ""
    },
    nativeOn: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.joinParty.apply(null, arguments);
      }
    },
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v;
      },
      expression: "input"
    }
  }), _c('div', {
    staticClass: "btnBox center"
  }, [_c('el-button', {
    attrs: {
      "width": 70
    },
    on: {
      "click": _vm.returnPage
    }
  }, [_vm._v(_vm._s(_vm.$t('start.cancel')))]), _c('el-button', {
    staticClass: "joinBtn",
    attrs: {
      "width": 70,
      "disabled": !_vm.input
    },
    on: {
      "click": _vm.joinParty
    }
  }, [_vm._v(_vm._s(_vm.$t('start.join')))])], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };